// extracted by mini-css-extract-plugin
export default {"heading":"Av-z","corrected":"Bv-z","redirectVerbiageContainer":"Cv-z","redirectVerbiageText":"Dv-z"};